import { useMemo } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentResourceOperation } from "types/generated";
import TableCellText from "ds/components/Table/Row/CellText";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import useCellCopyAction from "../useCellCopyAction";

const IntentProjectOperationsTableSessionCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<IntentResourceOperation>) => {
  const author = item.author || "";
  const copyAction = useCellCopyAction({
    text: author,
  });

  const isEmpty = !author;
  const actions = useMemo(() => (isEmpty ? undefined : [copyAction]), [copyAction, isEmpty]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}
      {!isEmpty && <TableCellText>{author}</TableCellText>}
    </TableSimpleCell>
  );
};

export default IntentProjectOperationsTableSessionCell;
